"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPushNotificationsEligible = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const isPushNotificationsEligible = (devicePlatform, systemVersion, region) => {
    const isValidAndroidVersion = devicePlatform.isAndroid && parseFloat(systemVersion !== null && systemVersion !== void 0 ? systemVersion : '') > 12;
    const isEligibleOSVersion = devicePlatform.isIOS || isValidAndroidVersion;
    const shouldShowPushNotifications = !devicePlatform.isDesktop &&
        region !== bridge_schema_1.AppRegion.China &&
        isEligibleOSVersion;
    return shouldShowPushNotifications;
};
exports.isPushNotificationsEligible = isPushNotificationsEligible;
